import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss'],
})
export class CookieConsentComponent implements OnInit {
  showBanner = false;

  ngOnInit(): void {
    if (this.getCookie('cookie_consent') !== 'true') {
      this.showBanner = true;
    }
  }

  acceptCookies(): void {
    this.setCookie('cookie_consent', 'true', 365);
    this.showBanner = false;
  }

  private setCookie(name: string, value: string, days: number): void {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date?.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }

  private getCookie(name: string): string | null {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    // prettier-ignore
    for (let i = 0; i < ca.length; i++) { //NOSONAR
      let c = ca[i];
      // prettier-ignore
      while (c.charAt(0) === ' ') { // NOSONAR
        c = c.substring(1, c.length);
      }
      // prettier-ignore
      if (c.indexOf(nameEQ) === 0) { //NOSONAR
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }
}
